import React from "react";

const HeroSection = () => {
  return (
    <div className="hero-section-wrapper hero-background">
      <div className="container hero-content">
        <h1 className="font-outfit main-heading-hero" style={{ fontSize: "45px" }}>
          Find Clarity in Your Relationships
        </h1>

        <p className="font-outfit sub-heading-hero">
          Patch things up, move forward, or explore
          <br />
          compatibility.
        </p>
      </div>
    </div>
  );
};

export default HeroSection;